import { boards as actions } from '../actions'

export const reducer = {}

reducer[actions.SET_BOARDS] = ({ state, action }) => {
  return { ...state, boards: action.boards }
}

reducer[actions.SET_SORT_TYPE] = ({ state, action }) => {
  return { ...state, sortType: action.sortType }
}

reducer[actions.SET_SEARCH_TEXT] = ({ state, action }) => {
  return { ...state, searchText: action.searchText }
}

reducer[actions.SET_LOADING] = ({ state, action }) => {
  return { ...state, loading: action.loading }
}
